import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

export const getPropertyDetailRoute = (
	propertyId: number | undefined,
): string =>
	propertyId !== undefined
		? Routing.Portfolio.PropertyDetail.path(String(propertyId))
		: Routing.Portfolio.PortfolioList.path();
